import { useEffect, useState } from 'react';
import apiClient from '@/lib/api/client';

// Spend by vendor across ALL jobs — receipts/invoices roll up here so you can
// see where the money goes and what's still owed per supplier.
interface Row { vendor: string; vendor_id?: number | null; expense_count: number; job_count: number; total: number; unpaid_total: number }

export function VendorSpendPanel() {
  const [rows, setRows] = useState<Row[]>([]);
  useEffect(() => {
    apiClient.get('/vendors/expense-rollup/all').then(r => setRows(r.data.data ?? [])).catch(() => {});
  }, []);
  if (!rows.length) return null;
  const money = (n: number) => `$${Number(n).toLocaleString('en-CA', { minimumFractionDigits: 2 })}`;
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
      <p className="px-4 pt-3 pb-1 text-sm font-bold text-gray-900 flex items-center gap-1.5">
        <span className="material-symbols-outlined text-[#C77D3F] text-lg">receipt_long</span>
        Spend by vendor (all jobs)
      </p>
      <table className="w-full text-sm min-w-[480px]">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wide text-gray-400 border-b border-gray-100">
            <th className="px-4 py-1.5 font-semibold">Vendor</th>
            <th className="px-3 py-1.5 font-semibold text-right">Receipts</th>
            <th className="px-3 py-1.5 font-semibold text-right">Jobs</th>
            <th className="px-3 py-1.5 font-semibold text-right">Total</th>
            <th className="px-3 py-1.5 font-semibold text-right">Unpaid</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {rows.map((r, i) => (
            <tr key={i}>
              <td className="px-4 py-2 font-medium text-gray-900">{r.vendor}</td>
              <td className="px-3 py-2 text-right text-gray-600">{r.expense_count}</td>
              <td className="px-3 py-2 text-right text-gray-600">{r.job_count}</td>
              <td className="px-3 py-2 text-right font-semibold text-gray-900">{money(r.total)}</td>
              <td className={`px-3 py-2 text-right font-semibold ${Number(r.unpaid_total) > 0 ? 'text-red-700' : 'text-gray-300'}`}>
                {Number(r.unpaid_total) > 0 ? money(r.unpaid_total) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
